export const ENTITY_REPORT_TOP = "entity-report-top";
